<template>
  <div>
    <h1 class="page-header">{{ $t('employee.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex">
          <ts-button color="info" outline @click="$router.push({ name: 'employee-create' })">
            {{ $t('addNew') }}
          </ts-button>
          <div class="ml-2 ts-rounded ts-border ts-px-2 ts-whitespace-no-wrap" style="width:227px">
            <div class="radio radio-css radio-inline">
              <input v-model="side" type="radio" id="front" :value="1" />
              <label for="front">
                {{ $t('employee.front') }}
              </label>
            </div>
            <div class="radio radio-css radio-inline">
              <input v-model="side" type="radio" id="back" :value="2" />
              <label for="back">
                {{ $t('employee.back') }}
              </label>
            </div>
            <ts-button class="btn-xs ml-3" :disabled="!checkedEmp.length > 0" color="primary" @click="printCard">
              {{ $t('employee.printCard') }}
            </ts-button>
          </div>
          <div class="ts-flex-grow"></div>
          <ts-input v-model="search" :placeholder="$t('search')" style="width:300px" class="ml-2" />
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :showCheckbox="true"
          @check-items="checkItem"
        >
          <template v-slot="{ record }">
            <td class="with-img">
              <img
                class="height-30 ts-rounded"
                v-lazy="{
                  src: photoEmp(record),
                  error: onError(record),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }"
              />
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.card_id }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.employee_name_kh }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.employee_name_en }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.sex }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.logical_position ? record.logical_position.position_name_en : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.phone }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.hire_date }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.shift ? record.shift.shift_name : '' }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.payroll_cycle_date ? record.payroll_cycle_date.pc_date_name : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.status.status }}</td>
            <td class="text-center">
              <a href="#" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="'Delete'"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import PreviewCard from './preview-card'

export default {
  name: 'employee',
  components: {
    PreviewCard
  },
  data() {
    return {
      model: {},
      loading: false,
      checkedEmp: [],
      side: 1, // 1 front, 2 back
      manPhoto: require('../../../assets/staff-default-man.png'),
      womenPhoto: require('../../../assets/staff-default-women.png')
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/employee', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.employee.search
      },
      set(newValue) {
        this.$store.commit('hr/employee/SET_SEARCH', newValue)
        this.$store.commit('hr/employee/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('employee.employeePhoto') },
        { name: this.$t('employee.cardId') },
        { name: this.$t('employee.employeeNameKh') },
        { name: this.$t('employee.employeeNameEn') },
        { name: this.$t('employee.sex') },
        { name: this.$t('employee.position') },
        { name: this.$t('employee.phone') },
        { name: this.$t('employee.hireDate') },
        { name: this.$t('employee.shift') },
        { name: this.$t('employee.payrollCycleDate') },
        { name: this.$t('employee.status') },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/employee/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('hr/employee/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'employee-edit',
        params: { id: record.employee_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('hr/employee/delete', record.employee_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    checkItem(value) {
      this.checkedEmp = []
      if (!_.isEmpty(value)) {
        value.forEach(element => {
          this.checkedEmp.push(element.employee_id)
        })
      }
    },
    printCard() {
      this.$modal.show(
        PreviewCard,
        {
          emp_id: this.checkedEmp,
          side: this.side
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    photoEmp(record) {
      if (record.photo) {
        return record.photo + '&api_token=' + this.$store.getters.accessToken
      }

      return record.sex == 'Male' ? this.manPhoto : this.womenPhoto
    },

    onError(record) {
      event.target.src = record.sex == 'Male' ? this.manPhoto : this.womenPhoto
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/employee/RESET_STATE')
    next()
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
